export default function checkoutCtrl($scope) {
    // accountScope = angular.element(document.getElementById('account-wrap')).scope();
    $scope.registerUserMobile = function () {
        $('#registerUserCheckout').addClass('loading').prop('disabled', true);
        angular.element(document.getElementById('account-wrap')).scope().registerUserOpen();
        // setTimeout(function(){
        //     $('#registerUserCheckout').removeClass('loading').prop('disabled', false);
        // }, 1000);
    }
}

checkoutCtrl.$inject = ['$scope'];